<template>
  <div class="collapsable-section">
    <div class="collapse-header">
      <BaseButton
        v-if="!hidden"
        kind="auxiliary"
        class="collapse-button"
        :tabindex="-1"
        @click="toggle"
      >
        <template #title>
          {{ header }}
        </template>
        <template #icon>
          <ChevronDownIcon />
        </template>
      </BaseButton>
      <BaseButton
        v-else
        kind="auxiliary"
        class="collapse-button"
        :tabindex="-1"
        @click="toggle"
      >
        <template #title>
          {{ header }}
        </template>
        <template #icon>
          <ChevronRightIcon />
        </template>
      </BaseButton>
    </div>
    <div class="collapse-body" :class="{ hidden }">
      <slot />
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref } from "vue";

import BaseButton from "@/components/base/BaseButton.vue";
import ChevronDownIcon from "@/components/icons/ChevronDownIcon.vue";
import ChevronRightIcon from "@/components/icons/ChevronRightIcon.vue";

export default defineComponent({
  components: {
    BaseButton,
    ChevronDownIcon,
    ChevronRightIcon,
  },
  props: {
    header: { type: String, required: true },
    hide: { type: Boolean, default: true },
  },
  setup(props) {
    const hidden = ref(props.hide);
    const toggle = () => (hidden.value = !hidden.value);
    return { hidden, toggle };
  },
});
</script>

<style lang="scss" scoped>
.collapse-header {
  margin: 4px 0 12px -4px;
  display: flex;
  align-items: center;
  gap: 0px;
  @extend %font-body-medium;
  @include themed() {
    color: t($grey-80);
  }
}

.collapse-body {
  padding-inline-start: 25px;
  display: flex;
  flex-direction: column;
  gap: 20px;

  &.hidden {
    display: none;
  }
}

.title {
  @extend %font-h4;
  font-weight: 500;
  display: flex;
  align-items: center;
  gap: 8px;
  margin-inline-end: 4px;
  @include themed() {
    color: t($primary);
  }
}

.task-count {
  font-weight: 300;
  @include themed() {
    color: t($grey-50);
  }
}

:deep(.collapse-button) {
  padding: 4px;

  .title {
    @extend .title;
  }

  .icon {
    svg {
      transition: transform 0.2s ease;

      &.expanded {
        transform: rotate(90deg);
      }
    }
  }
}
</style>
